import React, { useState } from 'react';
import { message } from 'antd';
import { useNavigate } from 'react-router-dom';
import { taskAccess } from '../../services/task_access';
import TaskAccess from './TaskAccess';

export default function useTaskOpen() {
  const navigate = useNavigate();
  const [requestId, setRequestId] = useState<string>();
  const openTask = async (id: string) => {
    try {
      const result = await taskAccess('status', { task_id: id });
      if (!result.allowed) { setRequestId(id); return; }
      window.scrollTo(0, 0);
      navigate(`/task/detail/${encodeURIComponent(id)}`, { state: { EventName: id } });
    } catch (error: any) { message.error(error.message); }
  };
  const accessPopup = requestId ? <TaskAccess requestId={requestId} onClose={() => setRequestId(undefined)} /> : null;
  return { openTask, accessPopup };
}
